import { render, staticRenderFns } from "./EventRules.vue?vue&type=template&id=2f8635f4&"
import script from "./EventRules.vue?vue&type=script&lang=ts&"
export * from "./EventRules.vue?vue&type=script&lang=ts&"
import style0 from "./EventRules.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports